import { trpc } from "lib/trpc";

export const usePublicUser = (id: number) => {
    const { data: user, isInitialLoading, error } = trpc.users.getPublic.useQuery({ id });

    return {
        user: user ?? null,
        isInitialLoading,
        error,
    };
};
